export default {"src":"/_next/static/media/arrow-right.65b396c7.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};